/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEllipsis2: {
  name: 'ellipsis-2';
  data: string;
} = {
  name: 'ellipsis-2',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
